import React, { useEffect, useState, useRef } from 'react';
import { X } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
interface OtpModalProps {
  email: string;
  onClose: () => void;
  onSuccess: () => void;
}
export function OtpModal({
  email,
  onClose,
  onSuccess
}: OtpModalProps) {
  const [code, setCode] = useState(['', '', '', '', '', '']);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [resendCooldown, setResendCooldown] = useState(60);
  const inputsRef = useRef<(HTMLInputElement | null)[]>([]);
  const {
    verifyOtp,
    sendOtp
  } = useAuth();
  useEffect(() => {
    if (resendCooldown > 0) {
      const timer = setTimeout(() => setResendCooldown(c => c - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [resendCooldown]);
  const handleChange = (index: number, value: string) => {
    if (!/^\d*$/.test(value)) return;
    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);
    if (value && index < 5) {
      inputsRef.current[index + 1]?.focus();
    }
  };
  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace' && !code[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };
  const handleVerify = async () => {
    const fullCode = code.join('');
    if (fullCode.length !== 6) return;
    setLoading(true);
    setError('');
    try {
      await verifyOtp(email, fullCode);
      onSuccess();
    } catch (err: any) {
      setError(err.message || 'Código inválido');
    } finally {
      setLoading(false);
    }
  };
  const handleResend = async () => {
    if (resendCooldown > 0) return;
    setLoading(true);
    try {
      await sendOtp(email);
      setResendCooldown(60);
    } catch (err) {
      setError('Error al reenviar');
    } finally {
      setLoading(false);
    }
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4" data-id="element-63">
      <div className="bg-growthly-surface w-full max-w-md rounded-[12px] shadow-[0_6px_18px_rgba(0,0,0,0.45)] border border-white/5 p-6 relative" data-id="element-64">
        <button onClick={onClose} className="absolute top-4 right-4 text-growthly-muted hover:text-white" data-id="element-65">
          <X size={20} data-id="element-66" />
        </button>

        <h2 className="text-[22px] font-semibold text-white mb-2" data-id="element-67">
          Ingresa el código
        </h2>
        <p className="text-[14px] text-growthly-muted mb-6" data-id="element-68">
          Enviado a {email}
        </p>

        <div className="flex justify-between mb-6" data-id="element-69">
          {code.map((digit, i) => <input key={i} ref={el => inputsRef.current[i] = el} type="text" maxLength={1} value={digit} onChange={e => handleChange(i, e.target.value)} onKeyDown={e => handleKeyDown(i, e)} className="w-12 h-12 text-center text-xl font-semibold bg-[#141414] border border-white/5 rounded-lg text-white focus:border-growthly-amber focus:outline-none focus:ring-1 focus:ring-growthly-amber transition-colors" data-id="element-70" />)}
        </div>

        {error && <p className="text-[#D64545] text-sm mb-4" data-id="element-71">{error}</p>}

        <button onClick={handleVerify} disabled={code.join('').length !== 6 || loading} className="w-full h-11 bg-white text-[#0B0B0B] font-medium rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center" data-id="element-72">
          {loading ? <div className="w-5 h-5 border-2 border-[#0B0B0B]/20 border-t-[#0B0B0B] rounded-full animate-spin" data-id="element-73" /> : 'Verificar'}
        </button>

        <div className="mt-4 text-center" data-id="element-74">
          <button onClick={handleResend} disabled={resendCooldown > 0 || loading} className="text-[14px] text-growthly-muted hover:text-white disabled:opacity-50 transition-colors" data-id="element-75">
            {resendCooldown > 0 ? `Reenviar código en ${resendCooldown}s` : 'Reenviar código'}
          </button>
        </div>
      </div>
    </div>;
}